import styles from './styles.module.scss';
import cn from 'classnames';
import React from 'react';

interface DividerProps {
  className?: string;
  label?: string;
  variant?: 'solid' | 'dashed' | 'dotted';
  thickness?: 'thin' | 'medium' | 'thick';
}

export const Divider: React.FC<DividerProps> = ({ className = '', label, variant = 'solid', thickness = 'medium' }) => {
  const getThicknessClass = () => {
    if (variant !== 'dashed') return {};

    switch (thickness) {
      case 'thin':
        return { [styles.dividerThin]: true };
      case 'thick':
        return { [styles.dividerThick]: true };
      default:
        return { [styles.dividerMedium]: true };
    }
  };

  if (label) {
    return (
      <div className={cn('d-flex align-items-center', className)}>
        <div
          className={cn('flex-grow-1', 'border-gray-300', {
            'border-bottom': variant === 'solid',
            'border-bottom-dashed': variant === 'dashed',
            'border-bottom-dotted': variant === 'dotted',
            ...getThicknessClass()
          })}
        ></div>
        <span className="px-3 text-gray-600">{label}</span>
        <div
          className={cn('flex-grow-1', 'border-gray-300', {
            'border-bottom': variant === 'solid',
            'border-bottom-dashed': variant === 'dashed',
            'border-bottom-dotted': variant === 'dotted',
            ...getThicknessClass()
          })}
        ></div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'border-gray-300',
        {
          'border-bottom': variant === 'solid',
          'border-bottom-dashed': variant === 'dashed',
          'border-bottom-dotted': variant === 'dotted',
          ...getThicknessClass()
        },
        className
      )}
    ></div>
  );
};
